/**
 * Leaf Zod schema for `ConversationMode` — kept dependency-free so it can be
 * imported by both `conversation-types.ts` and `conversation-schema.ts` /
 * `n8n-webhook-payload-schema.ts` without re-entering the module cycle.
 *
 * Background (P12-FU-3 fix): `conversation-types.ts` re-exports
 * `n8n-webhook-payload-schema.ts`, which transitively pulls in
 * `conversation-payloads.ts` → `conversation-schema.ts` → back into
 * `conversation-types.ts`. When that re-entry happened before the body of
 * `conversation-types.ts` had executed, `ConversationModeSchema` was
 * `undefined`, surfacing as a TDZ-style "Cannot read properties of undefined
 * (reading 'optional')" crash at app boot.
 *
 * IMPORTANT: This file may ONLY import from `zod`. Keep it a leaf.
 */
import { z } from 'zod';

// NOTE: project_create → project_briefing → scoping; project_update → update.
// 'demo' (spec 024) is externally-facing/untrusted: it never flows through the
// authenticated /api/v1/conversation routes — only /api/v1/demo/:token/*.
export const ConversationModeSchema = z.enum([
  'home',
  'scoping',
  'update',
  'interview',
  'demo',
]);

export type ConversationMode = z.infer<typeof ConversationModeSchema>;
